import { Pagination } from "@/domain/entities/Pagination";
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import convertPhoneNumber from "@/app/infrastructures/misc/common-library/ConvertPhoneNumber";
import { OptionsClass } from "./MainApp";
import { ClientDetailUpdate, ClientDetailUpdateItem } from './ClientManagement';
import { formatDate } from '@/app/infrastructures/misc/Utils';

export class ClientRegistrationEntities {
  pagination: Pagination;
  data: ClientRegistrationData[];

  constructor(pagination: Pagination, data: ClientRegistrationData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class ClientRegistrationData {
  id = 0;
  clientName = "";
  clientAlias = "";
  clientCode = "";
  clientStartDate = "";
  clientEndDate = "";
  clientStatus = "";
  rateVersionStatus = "";
  clientType = "";

  constructor(fields?: Partial<ClientRegistrationData>) {
    Object.assign(this, fields);
  }
}

export class ClientContact {
  clientContactName = "";
  clientContactJobTitle = "";
  clientContactPhone = "";
  clientContactEmail = "";

  constructor(fields?: Partial<ClientContact>) {
    Object.assign(this, fields);
  }
}
export class ClientLocation {
  id = 0;
  code = "";
  name = "";
  cityCode = "";
  countryCode = "";

  constructor(fields?: Partial<ClientLocation>) {
    Object.assign(this, fields);
  }
}
export class ClientCod {
  clientCodName = "";
  clientCodAddress = "";
  clientCodDistrict: any = "";
  clientCodPhone = "";
  clientCodCommission = "";

  constructor(fields?: Partial<ClientCod>) {
    Object.assign(this, fields);
  }
}
export class ClientCodAsDefault {
  defaultCodName = "";
  defaultCodAddress = "";
  defaultCodDistrict: any = "";
  defaultCodPhone = "";

  constructor(fields?: Partial<ClientCodAsDefault>) {
    Object.assign(this, fields);
  }
}
export class BankDetail {
  bankLabel = "";
  bankName = "";
  accountNo = "";
  accountName = "";
  email = "";
  logo = "";
  constructor(fields?: Partial<BankDetail>) {
    Object.assign(this, fields);
  }
}

export class ClientDiscount {
  productType = "";
  discount = 0;

  constructor(fields?: Partial<ClientDiscount>) {
    Object.assign(this, fields);
  }
}
export class ClientCurrentRate {
  clientCustomRateId = 0;
  clientStatusCustomRate = "";
  clientRateVersionStartDate = "";
  clientRateVersionEndate = "";
  clientStatusUpdatedAt = "";
  clientStatusUpdatedBy = "";
  clientStatusUpdatedReason = "";
  clientVersionBaseRate = "";
  clientDiscountBaseRate = 0;
  clientFileNameBaseRate = "";
  clientFileBaseRate = "";
  clientVersionCustomRate = "";
  clientFileNameCustomRate = "";
  clientFileCustomRate = "";
  clientErrorNameCustomRate = "";
  clientErrorFileCustomRate = "";
  clientStatusBulk = "";
  clientRateVersionCustom3lc = "";
  clientRatePriceType = "";
  clientRateInsuranceType = "";
  clientRateInsuranceValuePercentage = 0;
  clientRateUpdatedAt = "";
  discountProductTypes: ClientDiscount[] = [];
  isStuck = false;
  useClientDiscountConfig = true;

  constructor(fields?: Partial<ClientCurrentRate>) {
    Object.assign(this, fields);
  }
}
export class ClientPartner {
  clientPartnerId = 0;
  clientPartnerName = "";
  clientPartnerQuantifierCommission = "";
  clientPartnerCommissionAmount = 0;
  clientPartnerNumeratorCommision = "";

  constructor(fields?: Partial<ClientPartner>) {
    Object.assign(this, fields);
  }
}
export class ClientBilling {
  noWhatsAppFull = "";
  noWhatsApp = "";
  noWhatsAppDialCode = "";
  billingSchedule = "";
  timeRangePayment = "";
  email: Array<string> = [];
  startDate = "";
  endDate = "";
  attachment = "";
  attachmentUrl = "";
  pksAttachment = "";
  pksAttachmentUrl = "";
  constructor(fields?: Partial<ClientBilling>) {
    Object.assign(this, fields);
  }

  get formattedStartDate() {
    return formatDateWithoutTime(this.startDate);
  }
  get formattedEndDate() {
    return formatDateWithoutTime(this.endDate);
  }
  get formattedEmail() {
    return this.email.join(", ");
  }
  get formattedWhatsappNumber() {
    return `+${convertPhoneNumber(this.noWhatsApp)}`;
  }

  get fileNameAttachment() {
    return this.attachmentUrl.split("/").pop();
  }

  get fileNamePKSAttachment() {
    return this.pksAttachmentUrl.split("/").pop();
  }
}
export class ClientTax {
  NIK = "";
  NIKName = "";
  NIKAddress = "";
  isTaxPayer = false;
  taxNumber = "";
  taxPayerName = "";
  taxPayerAddress = "";
  transactionCode = "05 Besaran Tertentu";
  taxAttachment = "";
  taxAttachmentUrl = "";
  isEfakturWithNik = false;
  clientNikId = "";
  clientNikName = "";
  clientNikAddress = "";

  constructor(fields?: Partial<ClientTax>) {
    Object.assign(this, fields);
  }

  get fileNameTaxAttachment() {
    return this.taxAttachmentUrl.split("/").pop();
  }
}

export class ClientLiveRate {
  clientCustomRateId = 0;
  clientStatusCustomRate = "";
  clientStatusUpdatedAt = "";
  clientStatusUpdatedBy = "";
  clientStatusUpdatedReason = "";
  clientErrorNameCustomRate = "";
  clientErrorFileCustomRate = "";
  clientFileNameCustomRate = "";
  clientFileCustomRate = "";
  clientRatePriceType = "";
  clientRateInsuranceType = "";
  clientRateInsuranceValuePercentage = 0;
  clientRateCreatedAt = "";
  clientRateCreatedBy = "";
  clientRateActiveDate = "";
  totalDataProcessed = 0;
  totalData = 0;
  clientDiscountBaseRate = 0;
  clientRateVersionCustom3lc = "";

  constructor(fields?: Partial<ClientLiveRate>) {
    Object.assign(this, fields);
  }
}
export class ClientRegistrationDetail {
  id = 0;
  clientCode = "";
  clientCodeElexys = "";
  clientName = "";
  clientAlias = "";
  clientPhone = "";
  clientEmail = "";
  clientType = "";
  clientCategory = "";
  clientTaxNumber = "";
  clientStatus = "";
  clientAddress = "";
  clientDistrict = new ClientLocation();
  clientCity = new ClientLocation();
  clientStatusUpdatedAt = "";
  clientStatusUpdatedBy = "";
  clientStatusUpdatedReason = "";
  clientParentId = 0;
  clientParentName = "";
  clientPartner = new ClientPartner();
  clientContact = new ClientContact();
  clientIsCustomRate: any = "";
  clientIsRenewalCustomRate = false;
  clientIsCod = false;
  clientIsMixpack = false;
  clientIsDo = false;
  clientBranchDoPaymentType = "";
  clientCreatedAt = "";
  clientUpdatedAt = "";
  clientCreatedBy = "";
  clientUpdatedBy = "";
  clientCurrentRate = new ClientCurrentRate();
  clientRenewalRate: any = "";
  clientCodReject = new ClientCod();
  clientCodRejectAsDefault = new ClientCodAsDefault();
  clientBankName = "";
  clientBankNumber = "";
  clientBankEmail = "";
  clientBankLabel = "";
  dataProcessed = 0;
  totalData = 0;
  clientCompanySize = "";
  clientTax = new ClientTax();
  clientBilling = new ClientBilling();
  bankDetail = new BankDetail();
  bankSettlement = new BankDetail();
  clientPadFee = 0;
  clientPaymentMethod = new OptionsClass();
  clientCodConfigAmount = new OptionsClass();
  clientCodShipmentDiscount = "";
  clientIsDfod = false;
  isReturnConfig = false;
  returnConfigLimit = 0;
  returnConfigReasonIds = "";
  priceType = "";
  rateVersionCustom3lc = "";
  insuranceType = "";
  insuranceValuePercentage = 0;
  dataProcessedCurrent = 0;
  dataProcessedRenewal = 0;
  totalDataCurrent = 0;
  totalDataRenewal = 0;
  clientFreeze = false;
  clientIsNeedAssessment = false;
  detailUpdate = new ClientDetailUpdate();
  clientLiveRate = new ClientLiveRate();
  clientPerusahaan = "";
  clientCountry = "";
  clientIsNeedSplitSo = false;
  clientManagingCountryCode = "";
  clientManagingCountryName = "";

  constructor(fields?: Partial<ClientRegistrationDetail>) {
    Object.assign(this, fields);
    if (!fields?.clientPaymentMethod) {
      this.clientPaymentMethod = new OptionsClass();
    }
    if (!fields?.clientCodConfigAmount) {
      this.clientCodConfigAmount = new OptionsClass();
    }
    if (!fields?.clientCodShipmentDiscount) {
      this.clientCodShipmentDiscount = "0";
    } else {
      this.clientCodShipmentDiscount = String(
        fields?.clientCodShipmentDiscount
      );
    }
  }

  get rateUpdatedAt() {
    if (this.clientCurrentRate.clientStatusUpdatedAt) {
      return formatDate(this.clientCurrentRate.clientStatusUpdatedAt);
    }

    return formatDate(this.clientCreatedAt);
  }

  get rateUpdatedBy() {
    if (this.clientCurrentRate.clientStatusUpdatedBy) {
      return this.clientCurrentRate.clientStatusUpdatedBy;
    }

    return this.clientCreatedBy;
  }


  get newestUpdatedDetail() {
    const clientField = this.detailUpdate.newestUpdatedField.length
      ? this.detailUpdate.newestUpdatedField[0]
      : new ClientDetailUpdateItem({ // use client updated if there is no data in client_meta.update_detail
        updatedByName: this.clientUpdatedBy,
        updatedAt: formatDate(this.clientUpdatedAt),
        updatedById: 0,
        prevVal: "",
        currentVal: ""
      })

    return clientField
  }
}

export const clientPaymentMethodData: OptionsClass[] = [
  new OptionsClass({
    name: "Invoice",
    value: "invoice"
  }),
  new OptionsClass({
    name: "Split Bill",
    value: "split_bill"
  })
];

export const clientCodConfigAmountData: OptionsClass[] = [
  new OptionsClass({
    name: "Harga Barang",
    value: "goods_price"
  }),
  new OptionsClass({
    name: "Harga Barang + Ongkir Klien",
    value: "goods_price,total_tarif"
  })
];

export class ClientRateHistoryDetail {
  clientStatusCustomRate = "";
  clientStatusUpdatedAt = "";
  clientStatusUpdatedBy = "";
  constructor(fields?: Partial<ClientRateHistoryDetail>) {
    Object.assign(this, fields);
  }
}

export class ClientRateHistory {
  clientCustomRateId = 0;
  clientRatePriceType = "";
  requestType = "";
  labelRequestType = "";
  updatedAt = "";
  updatedByName = "";
  clientStatusCustomRate = "";
  history = [] as ClientRateHistoryDetail[];
  constructor(fields?: Partial<ClientRateHistory>) {
    Object.assign(this, fields);
  }
}
